import { FC, useEffect } from 'react';

interface FullScreenImageProps {
  src: string;
  onClose: () => void;
}

const FullScreenImage: FC<FullScreenImageProps> = ({ src, onClose }) => {
  useEffect(() => {
    const handleKeyDown = () => {
      onClose();
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);

  const handleClick = () => {
    onClose();
  };

  return (
    <div
      onClick={handleClick}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(0, 0, 0, 0.92)'
      }}
    >
      <img
        src={src}
        alt="Full Screen"
        onClick={handleClick}
        style={{ maxHeight: '90%', maxWidth: '90%' }}
      />
    </div>
  );
};

export default FullScreenImage;
